import { render, staticRenderFns } from "./joinDialog.vue?vue&type=template&id=3e39bb86&scoped=true"
import script from "./joinDialog.vue?vue&type=script&lang=js"
export * from "./joinDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39bb86",
  null
  
)

export default component.exports